import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '../../../utils/validators';
import Overlay from '../../../forms/_common/Overlay';
import FormErrors from '../../../forms/_common/FormErrors';
import RequestError from '../../../forms/_common/RequestError';
import ErrorMessage from '../../../forms/_common/ErrorMessage';
import FormTemplate from '../../../dialogs_common/SetupTemplate';
import PrimaryButton from '../../../components_setup/PrimarySetupButton';
import { useQueryMutation } from '../../../../hooks/@lore/query-connect';
import useTags from '../../../hooks/useTags';
import TagTypes from '../../../constants/TagTypes';
import useUserTags from '../../../hooks/useUserTags';
import EducatorIntentYes from './EducatorIntentYes';
import EducatorIntentNo from './EducatorIntentNo';

Form.propTypes = {
  user: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func,
  onSkip: PropTypes.func
};

export default function Form(props) {
  const {
    user,
    navigation,
    onNext,
    onPrevious,
    onSkip
  } = props;

  const intents = useTags(TagTypes.Intent);
  const userIntents = useUserTags(user, TagTypes.Intent);

  const [data, setData] = useState(_.pick(user.data, [
    'isEducator'
  ]));
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('currentUser.updateSingleton', user);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      onNext(data);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data);
  }

  function onChange(name, value) {
    setData(_.merge({}, data, {
      [name]: value
    }));
  }

  return (
    <div className="my-auto">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          // isEducator: [validators.boolean.isRequired],
          userIntents: [function(value) {
            if (userIntents.data.length < 1) {
              return 'Must select at least one intent';
            }
          }]
        }}>
          {({ errors, hasError }) => {
            return (
              <FormTemplate
                className="w-full"
                onPrevious={onPrevious}
                navigation={navigation}
                title="Do you currently work at a school that serves PreK-12 students?"
                alert={error ? (
                  <RequestError request={request} v2={true} />
                ) : showErrors ? (
                  <ErrorMessage v2={true}>
                    Please select an intent.
                  </ErrorMessage>
                ) : null}
                body={(
                  // <Intents
                  //   user={user}
                  //   intents={intents}
                  //   userIntents={userIntents}
                  // />
                  <div className="flex flex-col space-x-0 space-y-6">
                    <EducatorIntentYes
                      user={user}
                      intents={intents}
                      userIntents={userIntents}
                      onSubmit={onNext}
                    />
                    <EducatorIntentNo
                      user={user}
                      intents={intents}
                      userIntents={userIntents}
                      onSubmit={onSkip}
                    />
                  </div>
                )}
                footer={(
                  <>
                    {/*<div className="text-cs-orange-500 underline cursor-pointer mt-6 sm:mt-0 mr-0 sm:mr-12" onClick={onSkip}>*/}
                    {/*  No, I'm here for another reason.*/}
                    {/*</div>*/}
                    {/*<PrimaryButton disabled={hasError} onClick={() => hasError ? setShowErrors(true) : onSubmit()}>*/}
                    {/*  Yes, that's me!*/}
                    {/*</PrimaryButton>*/}
                  </>
                )}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </div>
  );
};
